export default {
    "启用": 1,
    "停用": 2,
    "帮助中心": 3,
    "编辑": 4,
    "复制": 5,
    "创建": 6,
    "数据总览": 7,
    "标签集市": 8,
    "用户标签": 9,
    "家庭标签": 10,
    "用户标签列表": 11,
    "家庭标签列表": 12,
    "标签体系说明": 13,
    "标签状态": 14,
    "家庭群体": 15,
    "个体人群": 16,
    "人群对比": 17,
    "标签圈人": 18,
    "LBS人群": 19,
    "批量获取地址": 20,
    "自定义上传": 21,
    "lookalike人群": 22,
    "组合人群": 23,
    "投后人群": 24,
    "算法人群": 25,
    "三方DMP人群": 26,
    "流量圈人": 27,
    "人群包拆分": 28,
    "活动人群": 29,
    "即将失效": 30,
    "流量洞察": 31,
    "配置中心": 32,
    "订单标签组合": 33,
    "电商标签每周流量洞察": 34,
    "问询管理": 35,
    "问询源包": 36,
    "推送列表": 37,
    "算法模型": 38,
    "标签配置": 39,
    "问询 API": 40,
    "创建问询API": 41,
    "编辑问询API": 42,
    "人群下载": 43,
    "FTP 管理": 44,
    "平台管理": 45,
    "失效人群": 46,
    "问询标签": 47,
    "项目标签": 48,
    "同步控制": 49,
    "自定义标签": 50,
    "标签发布": 51,
    "统计报表": 52,
    "三方问询": 53,
    "全量保存": 54,
    "匹配保存": 55,
    "已上线": 56,
    "已下线": 57,
    "京东系": 58,
    "超级红包": 59,
    "福利购": 60,
    "签到红包": 61,
    "福利直降": 62,
    "已创建": 63,
    "计算中": 64,
    "计算完成": 65,
    "计算失败": 66,
    "已删除": 67,
    "搜索项目名称/模型名称/种子人群ID": 68,
    "全部状态": 69,
    "创建模型": 70,
    "编辑成功": 71,
    "创建成功": 72,
    "创建须知": 73,
    "模型阈值区间0.01-0.99，默认为模型推荐阈值，可修改。": 74,
    "预测人群量级，单位为万，数值区间10-30000，即量级不超过3亿。指定量级时，按照预测得分高低顺序输出设备。": 75,
    "阈值和量级二选一输入数值，两者必须有一个有值。": 76,
    "新增预测模型需求，请发送邮件至ad-pm。": 77,
    "人群名称": 78,
    "请填写人群名称": 79,
    "输入字符过长": 80,
    "人群包名称不能包含/": 81,
    "所属项目": 82,
    "请选择所属项目": 83,
    "ID标识": 84,
    "请选择ID标识": 85,
    "请选择算法模型": 86,
    "模型阈值": 87,
    "请填写模型阈值": 88,
    "推荐阈值为*.**，数值区间0.01-0.99": 89,
    "预测人群量级（万）": 90,
    "请输入量级数值": 91,
    "取消": 92,
    "时间周期最长支持{}天": 93,
    "请选择时间周期": 94,
    "请选择订单标签任务": 95,
    "上传创建投后人群": 96,
    "时间周期最长支持选择六个月": 97,
    "自定义频次区间为左闭右开；比如设置1-6，则计算 1&lt;=频次&lt;6的数据": 98,
    "上传文件支持xlsx，xls格式": 99,
    "上传文件后需先进行校验，系统将校验所填订单/项目/计划ID是否存在于所选广告主下，请校验通过后再进行创建": 100,
    "上传模板样式": 101,
    "上传模板样式图": 102,
    "加密方式：": 103,
    "ID标识原值及加密说明": 104,
    "人群包如需要下载或者推送ftp，人群包名称建议使用英文字母和数字、下划线_组成，避免中文乱码显示问题。": 105,
    "ID标识只能选择纯明文（IDFA/OAID）或者纯密文（IDFA_MD5加密/IMEI_MD5加密/OAID_MD5加密）": 106,
    "广告主": 107,
    "搜索后显示": 108,
    "时间周期": 109,
    "转化": 110,
    "频次": 111,
    "不限": 112,
    "{}次及以上": 113,
    "自定义": 114,
    "次": 115,
    "终端类型": 116,
    "是否生成洞察": 117,
    "是": 118,
    "否": 119,
    "ID类型": 120,
    "加密方式": 121,
    "请选择加密方式": 122,
    "同天猫": 123,
    "同数坊&京东U+": 124,
    "不加密": 125,
    "是否自动更新": 126,
    "文件上传方式": 127,
    "本地文件上传": 128,
    "订单标签叉乘": 129,
    "上传文件": 130,
    "选择文件": 131,
    "支持": 132,
    "订单标签任务": 133,
    "下载模板": 134,
    "检查": 135,
    "时": 136,
    "累计更新": 137,
    "覆盖更新": 138,
    "活动人群ID标识只能选择IDFA和OAID": 139,
    "累计更新：": 140,
    "即增量更新，指人群包中保留自问询开始，所有的问询结果。": 141,
    "覆盖更新：": 142,
    "即全量更新，指人群包中只保留最新问询结果。": 143,
    "人群包ID超过数量限制,请先进行拆分": 144,
    "选择的ID标识与源人群包ID标识不一致": 145,
    "注意事项": 146,
    "1、不支持ID数量超过两亿的人群包生成三方DMP人群（oss离线问询除外）, 请先进行拆分再创建": 147,
    "前往拆分": 148,
    "2、文件目录下只保留问询文件，问询文件即您本次创建人群包所需要上传的文件。": 149,
    "3、当源人群类型为文件上传时，ftp中文件格式只能为csv、txt格式，文件数量可以是多个，文件内容只有第一列数据为设备ID,所有文件设备ID数量不超过2亿，文件大小不超过6G。": 150,
    "名称": 151,
    "问询频次": 152,
    "请选择问询频次": 153,
    "每日": 154,
    "每两天": 155,
    "每周": 156,
    "日问询时间": 157,
    "2+次问询包": 158,
    "更新方式": 159,
    "请选择更新方式": 160,
    "请选择开始时间": 161,
    "请选择结束时间": 162,
    "结束时间应大于开始时间": 163,
    "系统异常": 164,
    "1、时间周期最长支持选择3个月": 165,
    "时间类型": 166,
    "绝对时间": 167,
    "相对时间": 168,
    "开始日期": 169,
    "结束日期": 170,
    "最近": 171,
    "时间周期应大于0且小于等于90": 172,
    "天": 173,
    "请输入DealID": 174,
    "批量延期成功": 175,
    "批量延期": 176,
    "延期": 177,
    "本次已选中{}个人群包": 178,
    "有效期延长至": 179,
    "延期至": 180,
    "已同步状态同时延期": 181,
    "人群ID": 182,
    "最新人群数量": 183,
    "上传总数量": 184,
    "人群类型": 185,
    "提交日期": 186,
    "创建人": 187,
    "批量下载人群信息": 188,
    "本次下载人群信息已选中{}个人群包。下载信息选择：": 189,
    "源包类型为:{}, 不支持自动更新": 190,
    "今日延期次数已满": 191,
    "下线成功": 192,
    "上线成功": 193,
    "模型ID": 194,
    "模型路径": 195,
    "模型名称": 196,
    "种子人群ID": 197,
    "推荐阈值": 198,
    "状态": 199,
    "创建时间": 200,
    "修改时间": 201,
    "操作": 202,
    "下线": 203,
    "上线": 204,
    "请输入模型路径": 205,
    "项目名称": 206,
    "请输入项目名称": 207,
    "模型目标": 208,
    "请输入模型目标": 209,
    "请选择ID类型": 210,
    "模型上线日期": 211,
    "请选择模型上线日期": 212,
    "请输入推荐阈值": 213,
    "请输入推荐阈值，0.01-0.99之间": 214,
    "种子人群包ID": 215,
    "请输入种子人群包ID": 216,
    "模型描述": 217,
    "请输入文本描述": 218,
    "订单标签是指订单创建时所打的标签，顺序如下图。实现叉乘的前提是同一顺序的标签属于同一类。比如说标签1都是广告形式标签，标签2都是人群标签。": 219,
    "任务名称": 220,
    "请填写任务名称": 221,
    "任务名称不能包含/": 222,
    "人群名称前缀": 223,
    "请填写人群名称前缀": 224,
    "人群名称前缀不能包含/": 225,
    "请选择广告主": 226,
    "项目": 227,
    "请选择项目": 228,
    "计划": 229,
    "请选择计划": 230,
    "订单标签": 231,
    "请配置订单标签": 232,
    "订单标签任务名称搜索": 233,
    "新建任务": 234,
    "创建说明": 235,
    "1、YOYI源包上传目录为设备上传最新日期路径。每周日更新。": 236,
    "2、项目简称和策略简称只能英文字母和数字组成，不带任何特殊符号。": 237,
    "3、问询结果格式:download/项目简称/策略简称，问询结果是系统根据\"项目简称\"和\"策略简称\"自动生成的文件路径.": 238,
    "源包上传目录": 239,
    "项目简称": 240,
    "请填写项目简称": 241,
    "只能包含英文字母+数字，不带特殊符号": 242,
    "长度不超过20个字母": 243,
    "策略简称": 244,
    "请填写策略简称": 245,
    "只能包含英文字母+数字": 246,
    "运营需求": 247,
    "请填写运营需求": 248,
    "问询结果": 249,
    "名称长度不能超过50": 250,
    "请输入50字以内人群名称": 251,
    "批量人群洞察": 252,
    "本次已选中{}个人群包，确认后洞察开始计算": 253,
    "新建洞察任务成功": 254,
    "批量关注": 255,
    "本次关注已选中{}个人群包": 256,
    "关注成功": 257,
    "人群名称模糊搜索": 258,
    "京东人群": 259,
    "提示：您今天已延期{}个，还可延期{}个": 260,
    "生成中": 261,
    "已生成": 262,
    "序号": 263,
    "任务状态": 264,
    "完成时间": 265,
    "查看详情": 266,
    "下载": 267,
    "已失效": 268,
    "执行中": 269,
    "待执行": 270,
    "已完成": 271,
    "请填写 adzone_id 和 offer_id": 272,
    "请填写媒体pid": 273,
    "请选择红包类型": 274,
    "请输入adzone_id": 275,
    "请输入offer_id": 276,
    "请填写问询结果！": 277,
    "请输入Cosmose人群项目ID，不支持多个ID上传": 278,
    "请输入人群回传路径，格式为:/联通/项目简称_策略简称": 279,
    "请输入人群回传路径，格式为:电信/yy_industry": 280,
    "请选择问询结果！": 281,
    "请选择问询结果": 282,
    "请输入媒体pid": 283,
    "仅限英文字母/数字": 284,
    "请输入一个策略简称，仅限英文字母/数字": 285,
    "请从OSS浏览器复制相应路径,如 taobao/imei_download/result_cuhuo_code": 286,
    "请输入一个RTQID": 287,
    "请输入指定量级，如1000": 288,
    "请填写文件路径": 289,
    "路径校验失败": 290,
    "校验失败": 291,
    "数据文件HDFS路径": 292,
    "填写/复制一个文件路径": 293,
    "FTP 名称": 294,
    "请选择FTP": 295,
    "上传文件目录": 296,
    "请填写文件目录": 297,
    "人群包": 298,
    "文件上传": 299,
    "HDFS路径": 300,
    "源包来源": 301,
    "全量": 302,
    "指定数量": 303,
    "个，约 {} 万": 304,
    "批量复制": 305,
    "批量下载信息": 306,
    "{}个": 307,
    "{}个人群": 308,
    "请选择订单标签": 309,
    "最多可选择{}个订单标签叉乘": 310,
    "最多配置{}个标签值": 311,
    "配置标签值": 312,
    "请输入标签值名称，每行一个，最多{}行": 313,
    "标签{}": 314,
    "选择订单标签": 315,
    "有已选标签中未配置，请检查": 316,
    "叉乘后人群数量需要小于{}个，请重新配置标签": 317,
    "失败": 318,
    "实际人群数量会小于等于标签组合数量": 319,
    "单个人群支持最多4000个订单ID": 320,
    "源包人群名称": 321,
    "源包人群类型": 322,
    "副本人群名称": 323,
    "请输入人群包名称": 324,
    "代理商为空，选择代理商后再保存。": 325,
    "人群包名称为空，选择填写人群包名称后再保存。": 326,
    "批量复制成功": 327,
    "批量复制失败": 328,
    "批量创建DNA复制人群": 329,
    "代理商名称": 330,
    "请选择代理商，单选": 331,
    "DNA复制人群包名称": 332,
    "共批量选择{}个人群包，其中{}个人群包进行复制，见上方清单。": 333,
    "保存": 334,
    "单个文件最多支持200行，即一次最多支持批量创建200个人群": 335,
    "全部人群": 336,
    "我的人群": 337,
    "操作提示": 338,
    "确认恢复该人群包？": 339,
    "恢复成功": 340,
    "恢复失效人群": 341,
    "查看": 342,
    "DNA复制人群": 343,
    "请选择代理商": 344,
    "普通": 345,
    "高级": 346,
    "请上传Excel文件": 347,
    "只支持 excel, csv, txt": 348,
    "上传成功": 349,
    "文件设备ID": 350,
    "是否匹配洞察": 351,
    "数据保存方式": 352,
    "支持 xls, xlsx, csv, txt": 353,
    "上传须知": 354,
    "“文件设备ID”方式上传的文件只能有一列数据，如匹配结果为0，请先自查文件内容是否只有一列。": 355,
    "文件大小最大支持1G，如需上传大于1G的文件，请联系管理员。": 356,
    "“数据文件”方式，请输入HDFS路径，如：/user/ads/dmp/crowdDayTag/support-01": 357,
    "上传目的：上传创建完成后不会产生洞察，可立即设置同步。": 358,
    "提前一天": 359,
    "当选择oaid小写加密和全量保存时，已匹配ID将自动转换成oaid原值加密，未匹配ID直接保存上传的oaid小写加密数据。": 360,
    "文件最大{}G!": 361,
    "批量创建人群包对应数据文件": 362,
    "目标YES数量": 363,
    "请选择目标YES数量": 364,
    "为了不影响投放时间，请至少{}进行人群包上传,创建,并点击同步,直至同步完成": 365,
    "电商洞察": 366,
    "按名称搜索": 367,
    "人群数量：共计 {} 个": 368,
    "文件目录下只保留所需生成HDFS路径的文件。如有文件大小为0，则该文件不生成HDFS路径。": 369,
    "同一个文件夹中，所有文件大小之和小于2G。文件过大，可能受网络等影响导致任务失败。": 370,
    "文件内容只能有一列设备ID。": 371,
    "HDFS路径生成一个月之后将自动失效。请合理安排创建为上传人群。": 372,
    "FTP名称": 373,
    "请输入文件目录": 374,
    "请输入文件目录。如/upload/文件夹名称": 375,
    "HDFS生成方式": 376,
    "一对一": 377,
    "多对一": 378,
    "一对一：目录中的每个文件对应一个HDFS路径": 379,
    "多对一：目录中的多个文件合并成一个HDFS路径": 380,
    "保存成功": 381,
    "请输入FTP名称": 382,
    "FTP地址": 383,
    "请输入JAR包路径": 384,
    "请填写FTP地址": 385,
    "协议": 386,
    "端口": 387,
    "请对API支持的功能进行描述": 388,
    "请填写端口": 389,
    "账号": 390,
    "请填写账号": 391,
    "密码": 392,
    "请填写密码": 393,
    "目录": 394,
    "请填写目录": 395,
    "文件更新": 396,
    "请选择文件更新": 397,
    "覆盖": 398,
    "按日期追加": 399,
    "任务名称搜索": 400,
    "是否删除此条FTP": 401,
    "删除成功": 402,
    "维护时间": 403,
    "删除": 404,
    "HDFS数量": 405,
    "失效日期": 406,
    "上传创建": 407,
    "交": 408,
    "并": 409,
    "减": 410,
    "组合条件": 411,
    "组合结果": 412,
    "请选择人群": 413,
    "请选择需要组合的人群包": 414,
    "括号数量不匹配": 415,
    "不能以符号结尾": 416,
    "组合错误": 417,
    "重置": 418,
    "数量": 419,
    "类型": 420,
    "人群包已添加": 421,
    "共 {} 条": 422,
    "覆盖 YOYI ID": 423,
    "覆盖 Household ID 数": 424,
    "非": 425,
    "无": 426,
    "上一次": 427,
    "请配置标签组合": 428,
    "开始不能是符号，若是符号必须是\"(\"或\"非\"": 429,
    "\"非\"前必须有符号": 430,
    "\"(\"前不能为标签或者\")\"": 431,
    "请注意标签符号间隔": 432,
    "\")\"后面必须是符号": 433,
    "不能以非\")\"符号作为结束": 434,
    "括号不匹配": 435,
    "‘非’前需要有‘交’或者‘并’": 436,
    "选择条件": 437,
    "请选择标签": 438,
    "人群正在创建请稍后": 439,
    "编辑人群名称成功": 440,
    "默认填充": 441,
    "查看覆盖人群": 442,
    "搜索标签": 443,
    "匹配标签": 444,
    "已选标签": 445,
    "标签列表": 446,
    "请输入匹配内容，如: \"男,智能穿戴\"": 447,
    "默认条件": 448,
    "未匹配标签": 449,
    "已存在标签": 450,
    "请输入搜索内容": 451,
    "请输入标签名称": 452,
    "返回上级": 453,
    "LBS圈人": 454,
    "进入LBS搜索": 455,
    "地图创建": 456,
    "开": 457,
    "关": 458,
    "开启此开关将会生成每个LBS单独的人群包和人群集合的人群包；关闭此开关将只会生成人群集合的人群包": 459,
    "使用手册": 460,
    "按任务名称搜索": 461,
    "创建地址任务": 462,
    "是否确认删除？": 463,
    "是否指定地名": 464,
    "指定地名": 465,
    "关键词": 466,
    "搜索条件": 467,
    "最多上传1个文件!": 468,
    "仅支持": 469,
    "任务名称不能包含特殊字符": 470,
    "批量获取地址指定地名模板": 471,
    "百度查询": 472,
    "请输入任务名称": 473,
    "请输入任务名称，不超过30个汉字": 474,
    "请选择是否指定地名": 475,
    "请上传文件!": 476,
    "POI关键词": 477,
    "请输入POI关键词": 478,
    "输入关键词，支持多个关键字并集检索，不同关键字间以$符号分隔，最多支持3个关键字检索。如:”银行$酒店”": 479,
    "所属城市": 480,
    "请选择所属城市": 481,
    "请输入关键字": 482,
    "选中地域": 483,
    "全部删除": 484,
    "文件最大{}M!": 485,
    "请上传Excel文件!": 486,
    "开启生成LBS子包开关将会生成每个LBS单独的人群包和人群集合的人群包；关闭此开关将只会生成人群集合的人群包；如无特殊需求建议关闭": 487,
    "周边范围区间为左开右闭；比如设置1~5KM，则计算1<周边半径<=5的数据": 488,
    "上传文件格式支持xls,xlsx": 489,
    "上传文件需包含三列信息：地名、详细地址和所在城市。详见模板": 490,
    "最近半个月活跃人数": 491,
    "最近一个月活跃人数": 492,
    "最近两个月活跃人数": 493,
    "生成LBS子包": 494,
    "所选范围": 495,
    "请至少选择一个位置": 496,
    "请设置距离为 0-5km": 497,
    "请确认范围大小顺序": 498,
    "编辑人群成功": 499,
    "新建人群成功": 500,
    "人群没有修改": 501,
    "已选结果": 502,
    "清空": 503,
    "提交": 504,
    "全国": 505,
    "详情": 506,
    "地址": 507,
    "电话": 508,
    "没有匹配到经纬度": 509,
    "搜经纬度、查地点、找门店名": 510,
    "批量搜索": 511,
    "筛选城市": 512,
    "本页全选": 513,
    "扩散中": 514,
    "种子包名称": 515,
    "扩散条件": 516,
    "种子包数量": 517,
    "地域": 518,
    "媒体偏好": 519,
    "消费偏好": 520,
    "消费场景": 521,
    "扩散用户数": 522,
    "拆分数量不能为0": 523,
    "拆分包名称不能为空": 524,
    "目前只支持个体人群, ID类型为 Device 的人群包进行拆分": 525,
    "选择的ID标识与人群包的不匹配！": 526,
    "创建任务": 527,
    "选项只包含已生成，同步中，已同步的人群包.不包含不生成洞察的上传人群": 528,
    "选择人群": 529,
    "拆分文件数量": 530,
    "包": 531,
    "请输入包{}名称": 532,
    "条": 533,
    "约": 534,
    "未开始问询": 535,
    "开始问询": 536,
    "问询完成": 537,
    "暂停": 538,
    "操作成功": 539,
    "操作失败": 540,
    "推送日期": 541,
    "源包名称": 542,
    "问询开始时间": 543,
    "问询结束时间": 544,
    "问询数量": 545,
    "问询成功数量": 546,
    "问询失败数量": 547,
    "确认开始问询?": 548,
    "确认暂停问询?": 549,
    "暂停问询": 550,
    "确认重新问询?": 551,
    "重新问询": 552,
    "提升": 553,
    "下降": 554,
    "全部": 555,
    "待下发": 556,
    "下发中": 557,
    "成功": 558,
    "请筛选状态": 559,
    "推送开始时间": 560,
    "推送结束时间": 561,
    "推送数量": 562,
    "确认重推?": 563,
    "重推": 564,
    "每个文件匹配需1.5小时，请您耐心等待，计算完成时间与提交文件的多少有关。": 565,
    "同天猫：": 566,
    "IMEI MD5加密：原值小写，加密后32位小写；": 567,
    "IDFA MD5加密：原值大写，加密后32位小写；": 568,
    "OAID MD5加密：原值，加密后32位小写。": 569,
    "同数坊&京东U+：": 570,
    "OAID MD5加密：原值小写，加密后32位小写。": 571,
    "不加密：": 572,
    "IDFA：原值大写，长度为36位；OAID：原值，长度不定。": 573,
    "渠道": 574,
    "请输入渠道": 575,
    "直投媒体": 576,
    "请输入直投媒体": 577,
    "广告位ID": 578,
    "请输入广告位ID": 579,
    "多个ID请用,号分隔": 580,
    "请填写开始时间": 581,
    "订单": 582,
    "请选择媒体": 583,
    "转化类型": 584,
    "请选择转化类型": 585,
    "无此人群": 586,
    "激活": 587,
    "唤活": 588,
    "注册": 589,
    "订单量": 590,
    "首购量": 591,
    "加购物车": 592,
    "收藏": 593,
    "app吊起": 594,
    "次日留存": 595,
    "其他": 596,
    "不回传": 597,
    "直投": 598,
    "联合频控": 599,
    "个人": 600,
    "家庭": 601,
    "同步中": 602,
    "已同步": 603,
    "匹配数量小于500": 604,
    "全部类型": 605,
    "转换人群": 606,
    "家庭人群": 607,
    "我关注的人群": 608,
    "第三方 cookie": 609,
    "最近半个月": 610,
    "最近一个月": 611,
    "最近两个月": 612,
    "活跃人数": 613,
    "地域分布": 614,
    "曝光": 615,
    "点击": 616,
    "曝光未点击": 617,
    "点击未转化": 618,
    "区间": 619,
    "源包": 620,
    "新包": 621,
    "源包+新包": 622,
    "IDFA MD5加密": 623,
    "IMEI MD5加密": 624,
    "Android ID MD5加密": 625,
    "OAID MD5加密": 626,
    "条件": 627,
    "人群类型ID": 628,
    "匹配数量": 629,
    "计划数量": 630,
    "人群扩散倍数": 631,
    "源包类型": 632,
    "源包ID类型": 633,
    "源包上传路径": 634,
    "匹配率": 635,
    "所属层级": 636,
    "自定义标签名称": 637,
    "总用户量": 638,
    "阈值": 639,
    "维护日期": 640,
    "数据更新时间": 641,
    "绝对值": 642,
    "确认": 643,
    "人群ID转换": 644,
    "转换人群名称": 645,
    "转换人群类别": 646,
    "转换人群ID类型": 647,
    "复制到Plus": 648,
    "请填写代理商名称": 649,
    "延期成功": 650,
    "失效时间": 651,
    "扩散成功": 652,
    "扩散人群": 653,
    "扩散": 654,
    "lookalike名称": 655,
    "请输入扩散后人群名称": 656,
    "人群扩散条件": 657,
    "请选择人群扩散条件": 658,
    "选择了不限，不能再选其它扩散条件": 659,
    "请填写扩散倍数": 660,
    "扩散倍数1~10倍": 661,
    "倍": 662,
    "当前状态数量": 663,
    "人群总数": 664,
    "开始组合": 665,
    "人群包自动更新": 666,
    "任务暂未开始，请稍后再试": 667,
    "正在生成人群包，请稍后再试": 668,
    "人群包正在同步中，请稍后再试": 669,
    "人群包已失效，不支持自动更新": 670,
    "活动人群不支持自动更新": 671,
    "修改自动更新状态为": 672,
    "非自动更新": 673,
    "自动更新": 674,
    "修改成功": 675,
    "最多选择20个人群包进行组合": 676,
    "ID 类型不同不能进行组合": 677,
    "未生成 lookalike，不支持组合": 678,
    "人群包已失效，不支持组合": 679,
    "最多选择2个人群包进行对比": 680,
    "比较人群": 681,
    "ID类型为空的人群不支持对比": 682,
    "人群转换": 683,
    "人群包已失效，不支持扩散": 684,
    "只支持 Household ID 与 Device 互转": 685,
    "“此人群包为PLUS创建，不支持复制到PLUS": 686,
    "正在生成人群包，不可删除": 687,
    "正在同步人群包，不可删除": 688,
    "人群包已同步到PLUS，不可删除": 689,
    "DMP 人群包不能删除": 690,
    "确定删除人群: {} ?": 691,
    "正在同步人群包，不支持编辑": 692,
    "人群包已失效，不支持编辑": 693,
    "模糊搜索生成的LBS，不支持编辑": 694,
    "推送 FTP": 695,
    "洞察计算中": 696,
    "人群洞察": 697,
    "人群洞察计算中，请计算完成后点击人群洞察按钮查看洞察结果": 698,
    "正在生成洞察，请稍后再试": 699,
    "人群包已失效，不能进行洞察": 700,
    "此人群包没有选择生成洞察, 或ID类型不支持洞察": 701,
    "请先选择ID类型": 702,
    "人数少于{}不能进行洞察": 703,
    "人群包已失效，不能查看详情": 704,
    "人数少于500或大于100万不能进行扩散": 705,
    "取消关注": 706,
    "关注": 707,
    "失效人群不可设置关注操作": 708,
    "确定取消关注:": 709,
    "确定关注:": 710,
    "更新记录": 711,
    "人群包名称": 712,
    "人群包ID": 713,
    "数据日期": 714,
    "当日增量": 715,
    "总数量": 716,
    "人群包更新记录": 717,
    "保存本页为图片": 718,
    "“人群洞察报告”下载": 719,
    "个人画像下载": 720,
    "高": 721,
    "低": 722,
    "北京市": 723,
    "天津市": 724,
    "上海市": 725,
    "重庆市": 726,
    "河北省": 727,
    "山西省": 728,
    "辽宁省": 729,
    "吉林省": 730,
    "黑龙江省": 731,
    "江苏省": 732,
    "浙江省": 733,
    "安徽省": 734,
    "福建省": 735,
    "江西省": 736,
    "山东省": 737,
    "河南省": 738,
    "湖北省": 739,
    "湖南省": 740,
    "广东省": 741,
    "海南省": 742,
    "四川省": 743,
    "贵州省": 744,
    "云南省": 745,
    "陕西省": 746,
    "甘肃省": 747,
    "青海省": 748,
    "台湾省": 749,
    "内蒙古自治区": 750,
    "广西壮族自治区": 751,
    "西藏自治区": 752,
    "宁夏回族自治区": 753,
    "新疆维吾尔自治区": 754,
    "香港特别行政区": 755,
    "澳门特别行政区": 756,
    "占人群包比重": 757,
    "TGI指数": 758,
    "人群数量": 759,
    "占比": 760,
    "概览画像": 761,
    "家庭属性": 762,
    "电视品牌": 763,
    "APP类别": 764,
    "人口属性": 765,
    "上网特征": 766,
    "TOP50 显著特征": 767,
    "家庭结构": 768,
    "性别分布": 769,
    "年龄分布": 770,
    "成员年龄": 771,
    "跨屏数量": 772,
    "节目偏好": 773,
    "兴趣偏好": 774,
    "购物倾向": 775,
    "选择条件: 无": 776,
    "时间选择": 777,
    "种子人群数": 778,
    "扩散人群数": 779,
    "洞察日期": 780,
    "洞察进度": 781,
    "洞察链接": 782,
    "洞察完成时间": 783,
    "洞察创建时间": 784,
    "LBS名称": 785,
    "城市": 786,
    "人群名称/人群ID模糊搜索": 787,
    "任务进度": 788,
    "创建流量洞察": 789,
    "无匹配人群": 790,
    "人群流量洞察正在生成，请稍后再试": 791,
    "人群流量洞察已创建成功": 792,
    "人群流量洞察创建": 793,
    "新建洞察": 794,
    "源人群类型": 795,
    "源人群包": 796,
    "请选择 API": 797,
    "标签名称模糊搜索": 798,
    "标签名称": 799,
    "添加人群包": 800,
    "添加子标签": 801,
    "请输入叶子标签名称": 802,
    "长度不超过{}字节": 803,
    "子标签已保存": 804,
    "标签id": 805,
    "叶子标签名称": 806,
    "输入标签名称，长度不超过50字节": 807,
    "人群包添加成功": 808,
    "人群包超过20个": 809,
    "永久": 810,
    "创建人群": 811,
    "注意：文件格式为：店名、地理位置、所在城市": 812,
    "注意：如果支持的LBS较多，输出结果可能需要48小时以上，还请谨慎提交并耐心等待": 813,
    "请输入20字以内人群名称": 814,
    "请输入搜索条件": 815,
    "请输入地方名称": 816,
    "同步进度": 817,
    "待开始": 818,
    "读取中": 819,
    "返回首页": 820,
    "用户无权限": 821,
    "用户无权限访问该页面...": 822,
    "登录失败": 823,
    "DNA是悠易互通旗下的、面向开发者推出的用户行为分析产品，帮助客户通过精细化运营工具实现产品的快速增长。": 824,
    "账号：": 825,
    "请输入用户名!": 826,
    "密码：": 827,
    "请输入密码!": 828,
    "阅读并接受": 829,
    "悠易隐私政策": 830,
    "登录": 831,
    "退出登录": 832,
    "人群报表": 833,
    "请填写自定义标签名称": 834,
    "自定义标签名称模糊搜索": 835,
    "确认删除该自定义标签？": 836,
    "全部标签": 837,
    "我的标签": 838,
    "API名称": 839,
    "API平台ID": 840,
    "描述": 841,
    "是否删除此条API": 842,
    "按API名称搜索": 843,
    "请输入API名称": 844,
    "API描述": 845,
    "人群包创建": 846,
    "并行度": 847,
    "最大为100": 848,
    "授权代理商": 849,
    "搜索TASK名称、TASKID、APP名称": 850,
    "是否删除此条": 851,
    "TASK名称": 852,
    "任务类型": 853,
    "app名称": 854,
    "创建须知：": 855,
    "由于taskid对应的app名称和所属系别修改会影响标签数据，运营注意以下事项：": 856,
    "创建时，需要确认无误才可保存，": 857,
    "若taskid未开始问询前，可以编辑，": 858,
    "若taskid已经问询，修改taskid、app名称、app所属系别，需及时通知产品和技术回滚数据。": 859,
    "请选择API名称": 860,
    "选择API名称": 861,
    "请输入TASKID": 862,
    "请输入TASK名称": 863,
    "TASK类型": 864,
    "请输入TASK类型": 865,
    "APP名称": 866,
    "请输入APP名称": 867,
    "所属系别": 868,
    "请输入所属系别": 869,
    "开始日期-结束日期": 870,
    "平台名称": 871,
    "请输入台名称": 872,
    "请输入平台符号": 873,
    "平台符号": 874,
    "确认删除？": 875,
    "人群包下载": 876,
    "一方标签下载": 877,
    "下载ID类型": 878,
    "文件数量": 879,
    "复制成功": 880,
    "复制链接": 881,
    "是否删除此条记录": 882,
    "文件不存在": 883,
    "是否删除此条记录？": 884,
    "下载类型": 885,
    "待定": 886,
    "通过": 887,
    "拒绝": 888,
    "已拒绝": 889,
    "已通过": 890,
    "同步成功": 891,
    "ID数量": 892,
    "同步用户": 893,
    "同步广告主": 894,
    "提交时间": 895,
    "结果": 896,
    "审核时间": 897,
    "审核人": 898,
    "用户": 899,
    "地理位置": 900,
    "DNA家庭标签在媒体偏好，消费偏好，节目偏好，地理位置每个维度Household ID覆盖量前100的叶子标签": 901,
    "DNA标签在地理位置，媒体偏好，消费偏好，消费场景每个维度YOYI ID覆盖量前100的叶子标签": 902,
    "标签云": 903,
    "展示HouseholdID和其中可跨屏部分的数量情况": 904,
    "OAID，ANDROID,YOYI Cookie都表示能与主ID的数量；（主ID包括IMEI、OAID、IDFA、Cookie）": 905,
    "ID 图谱": 906,
    "标签分布": 907,
    "基础分类": 908
}